'use strict';

(function initExpressAvalaraDebug() {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !window.jQuery) {
        return;
    }

    if (window.__avalaraExpressDebugInstalled) {
        return;
    }

    window.__avalaraExpressDebugInstalled = true;

    var EXPRESS_ENDPOINT_MARKERS = [
        'Paypal-GetPaypalOrderId',
        'Paypal-GetBasketData',
        'StripePaymentsAPM-StripeQuickCheckout',
        'StripePaymentsAPM-GetStripeOrderItems'
    ];

    function findMarker(url) {
        if (!url) {
            return null;
        }

        for (var i = 0; i < EXPRESS_ENDPOINT_MARKERS.length; i++) {
            var marker = EXPRESS_ENDPOINT_MARKERS[i];
            if (url.indexOf(marker) !== -1) {
                return marker;
            }
        }

        return null;
    }

    function safeParseJSON(text) {
        if (!text) {
            return null;
        }

        try {
            return JSON.parse(text);
        } catch (e) {
            return null;
        }
    }

    function extractTaxSnapshot(payload) {
        if (!payload || typeof payload !== 'object') {
            return {};
        }

        var order = payload.order || {};
        var totals = order.totals || {};

        return {
            tax: payload.tax || payload.totalTax || totals.totalTax || totals.totalTaxValue || null,
            amount: payload.amount || totals.grandTotal || totals.grandTotalValue || null,
            currency: payload.currencyCode || payload.currency || totals.currencyCode || null,
            basketOrOrderUUID: order.basketUUID || order.UUID || order.orderNumber || null,
            avataxTax: order.ATTax || null,
            avataxTaxDetail: order.ATTaxDetail || null
        };
    }

    $(document).ajaxSend(function (_event, _xhr, settings) {
        var marker = findMarker(settings && settings.url);
        if (!marker) {
            return;
        }

        window.__avalaraExpressLastEndpoint = marker;
        window.console.info('[AvaTax][Express] Recalculation request started', {
            endpoint: marker,
            url: settings.url
        });
    });

    $(document).ajaxComplete(function (_event, xhr, settings) {
        var marker = findMarker(settings && settings.url);
        if (!marker) {
            return;
        }

        var payload = safeParseJSON(xhr && xhr.responseText);
        window.console.info('[AvaTax][Express] Recalculation response received', {
            endpoint: marker,
            snapshot: extractTaxSnapshot(payload)
        });
    });

    if (!window.__avalaraOriginalWindowOpen && typeof window.open === 'function') {
        window.__avalaraOriginalWindowOpen = window.open;
        window.open = function () {
            window.console.info('[AvaTax][Express] Popup window opening', {
                lastRecalculationEndpoint: window.__avalaraExpressLastEndpoint || 'unknown'
            });

            return window.__avalaraOriginalWindowOpen.apply(window, arguments);
        };
    }
})();
